// @flow

import { useIncomingPayment, getMerchant } from '../incoming-payment';
import { getThemeId } from './get-theme-id';

export function useThemeId(): string {
  const incomingPayment = useIncomingPayment();
  return getThemeId(getMerchant(incomingPayment));
}
